export class CompanyLicenseStateApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCompanyLicenseState({ companyId, config = {} }) {
    return this.#http.get(`/api/companies/${companyId}/state-licenses`, config);
  }

  async createCompanyLicenseState({ companyId, ...body }) {
    return this.#http.post(`/api/companies/${companyId}/state-licenses`, body);
  }

  async editCompanyLicenseState({ companyId, licenseId, ...body }) {
    return this.#http.put(`/api/companies/${companyId}/state-licenses/${licenseId}`, body);
  }

  async deleteCompanyLicenseState({ companyId, licenseId }) {
    return this.#http.delete(`/api/companies/${companyId}/state-licenses/${licenseId}`);
  }
}
